<template>
    <div class="content_box mobile_content">
        <div class="top">
            <div class="title">
                <span>多设备绑定用户</span>
            </div>&nbsp;&nbsp;
            <el-select v-model="region" placeholder="请选择" class="region-select" @change="regionChanged">
                <el-option label="美洲数据中心" value="us"></el-option>
                <el-option label="中国数据中心" value="cn"></el-option>
                <el-option label="欧洲数据中心" value="eu"></el-option>
                <el-option label="亚太数据中心" value="ap"></el-option>
            </el-select>
        </div>
        <div class="area">
            <div class="content">
                <div class="search_box">
                    <el-form :inline="true" class="demo-form-inline search-form form-list" label-width="100px">
                        <el-form-item label="最小绑定数" class="form_item bind_count_item">
                            <el-input
                                type="number"
                                min="2"
                                max="999"
                                v-model.number="searchData.min_count"
                                placeholder="≥2">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="注册时间" class="form_item date_picker">
                            <DatePicker :date="createTime" :clearable="true" @dateSelect="dateSelect"></DatePicker>
                        </el-form-item>
                        <el-form-item>
                            <div class="button search" @click="search">
                                <span>查询</span>
                            </div>
                          
                            <div class="button search export"
                                @click="exportList"
                                v-if="$store.state.type == 'pc' && roleCheck('102-101-102-102')">
                                <span>导出</span>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <el-table
                    :data="userList"
                    :fit="true"
                    style="width:100%"
                    highlight-current-row
                    :default-sort="{prop: 'bind_count', order: 'descending'}"
                    @sort-change="sortChange">
                    <el-table-column prop="aliUserId" label="用户ID" min-width="180" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span>{{scope.row.aliUserId || '--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="username" label="用户名" min-width="160"></el-table-column>
                    <el-table-column prop="region" label="国家/地区" min-width="110">
                    </el-table-column>
                    <el-table-column prop="productName" label="产品型号" min-width="180" show-overflow-tooltip>
    
                    </el-table-column>
                    <el-table-column prop="deviceName" label="设备 SN " min-width="220" show-overflow-tooltip>
                      
                    </el-table-column>
                    
                    <el-table-column prop="bindTime" sortable="custom" label="设备绑定时间" min-width="160">
                    </el-table-column>
                    <el-table-column prop="createTime" sortable="custom" label="注册时间" min-width="160">
                    </el-table-column>
        
                </el-table>
                <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'multi-bind-user',
    data() {
        return {
            region: 'us',
            createTime: [],
            searchData: {
                page_size: 10,
                page: 1,
                min_count: 2,
                reg_start_time: 0,
                reg_end_time: 0,
            },
            userList: [],
            total: 0
        };
    },
    watch: {
        createTime: function (nTime) {
            if (nTime && nTime.length > 1) {
                const start = new Date(nTime[0]);
                start.setHours(0, 0, 0, 0);
                const end = new Date(nTime[1]);
                end.setHours(23, 59, 59, 999);
                this.searchData.reg_start_time = Math.floor(start.getTime() / 1000);
                this.searchData.reg_end_time = Math.floor(end.getTime() / 1000);
            } else {
                this.searchData.reg_start_time = '';
                this.searchData.reg_end_time = '';
            }
        }
    },
    created() {
        if (!this.$route.query.region) {
            this.$router.replace('?region=us');
        }
        this.region = this.$route.query.region || this.region;
        this.getList();
    },
    methods: {
        init() {
            this.searchData = {
                page_size: 10,
                page: 1,
                min_count: 2,
                reg_start_time: '',
                reg_end_time: '',
            };
            this.createTime = [];
        },
        dateSelect(date) {
            this.createTime = date ? [...date] : [];
        },
        regionChanged(val) {
            this.region = val;
            this.$router.replace('?region=' + val);
            this.userList = [];
            this.total = 0;
            this.search();
        },
        search() {
            if (!this.searchData.min_count || this.searchData.min_count < 2) {
                this.searchData.min_count = 2;
            }
            this.searchData.page = 1;
            this.getList();
        },
        getList() {
            this.api.getMultiBindUserList(this.searchData).then(data => {
                if (!data) return;
                this.userList = (data.data && data.data.list) || [];
                this.total = (data.data && data.data.total) || 0;
            });
        },
        sortChange(sort) {
            // order_by 与 user-manage.vue 一致：1/2 = create_time asc/desc，3/4 = last_time asc/desc
            // 这里扩展：5/6 = bind_count asc/desc
          //  if (sort.prop == 'create_time') {
        //        this.searchData.order_by = (!sort.order || sort.order == 'descending') ? 2 : 1;
        //    } else if (sort.prop == 'last_time') {
          //      this.searchData.order_by = (!sort.order || sort.order == 'descending') ? 4 : 3;
         //   } else if (sort.prop == 'bind_count') {
        //        this.searchData.order_by = (!sort.order || sort.order == 'descending') ? 6 : 5;
         //   }
            this.search();
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        goDetail(row) {
            if (!row.ali_user_id) return;
            if (window.h5sdk) {
                this.$router.push({
                    name: 'user-detail',
                    params: { id: row.ali_user_id },
                    query: { region: this.region }
                });
                return;
            }
            const page = this.$router.resolve({
                name: 'user-detail',
                params: { id: row.ali_user_id },
                query: { region: this.region }
            });
            window.open(page.href, '_blank');
        },
        exportList() {
            const params = { ...this.searchData };
             params.page=1;
             params.page_size=99999;
            this.api.multiBindUserExport(params).then(() => {});
        }
    }
};
</script>

<style lang="less" scoped>
.content_box {
    padding: 0;
}

/deep/.top {
    .flexLayout(space-between);
    padding: 20px;
    background-color: @colorWhite;
    .el-input__inner {
        height: 32px;
        line-height: 32px;
    }
    .el-input__icon {
        line-height: 32px;
    }
    @media (max-width: 768px) {
        .el-input__inner {
            height: 28px;
            line-height: 28px;
        }
        .el-input__icon {
            line-height: 28px;
        }
    }
}

.area {
    padding: 20px;
    height: calc(100% - 80px);
    box-sizing: border-box;

    .content {
        background-color: @colorWhite;
        border-radius: 8px;
        padding: 20px;
        box-sizing: border-box;
    }

    .tip-bar {
        display: flex;
        align-items: center;
        background: #F5F8FF;
        border-left: 3px solid #507FF7;
        border-radius: 4px;
        padding: 8px 12px;
        margin-bottom: 16px;
        font-size: 12px;
        color: #555;
        .icon-tip {
            width: 14px;
            height: 14px;
            margin-right: 8px;
        }
    }

    .bind_count {
        display: inline-block;
        min-width: 36px;
        padding: 2px 10px;
        background: #EAF1FF;
        color: #507FF7;
        border-radius: 10px;
        font-weight: 500;
    }

    .export {
        width: 72px;
    }

    /deep/ .bind_count_item {
        .el-input-number {
            width: 130px;
            .el-input__inner {
                text-align: left;
                padding-left: 12px;
            }
        }
    }

    @media (max-width: 768px) {
        padding: 12px;
        .content {
            padding: 12px;
        }
        .el-form.form-list .el-form-item {
            margin-right: 0 !important;
        }
        /deep/ .bind_count_item {
            .el-input-number {
                width: 100%;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/view/statistics/app/multi-bind-user.vue